export default "__VITE_ASSET__DSYOV_R1__"